// src/components/modals/Toast.jsx
import React, { useEffect } from 'react';

export const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  
  const bg = type === 'error' ? 'bg-red-600' : 'bg-green-600';
  
  return (
    <div className="fixed top-4 right-4 z-[500] animate-in slide-in-from-right">
      <div className={`${bg} text-white px-4 py-2 rounded-lg shadow-lg text-xs font-semibold`}>
        {message}
      </div>
    </div>
  );
};